var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category"},[_c('sidebar',{staticClass:"left",attrs:{"list":_vm.sidebar,"activeIndex":_vm.sidebarIndex},on:{"seleced":_vm.seleced}}),_c('goods',{staticClass:"right",attrs:{"goodsInfo":_vm.goodsList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }